// Components/Forms/Fields/TextField.tsx
import type React from 'react';
import { FormField } from './FormField';
import { TextControl } from './Controls/TextControl';

type TextFieldProps = {
  name: string;
  label: React.ReactNode;

  className?: string;
  placeholder?: string;

  /** Optional overrides */
  type?: React.HTMLInputTypeAttribute;
  disabled?: boolean;
  loading?: boolean;

  /**
   * Optional parse function (e.g. trim, convert "" to undefined, etc.)
   * If omitted, raw string value is used.
   */
  parse?: (raw: string) => any;
};

export const TextField = ({ name, label, className, ...controlProps }: TextFieldProps) => {
  return (
    <FormField name={name} label={label} className={className}>
      <TextControl name={name} {...controlProps} />
    </FormField>
  );
};
